webpackJsonp([7538477671963],{

/***/ 446:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Windpro's blog","subtitle":"Python, JavaScript 全栈之路.","copyright":"© All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"Categories","path":"/categories/"},{"label":"About me","path":"/about/"}],"author":{"name":"Windpro Zhao","email":"windprog@gmail.com","telegram":"#","twitter":"#","github":"windprog","rss":"/rss.xml","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/rabbitmq-python-introduction","categorySlug":"/categories/python/"},"frontmatter":{"title":"RabbitMQ python 入门教程","date":"2018-04-06 10:50:05","category":"Python","description":"RabbitMQ是实现AMQP（高级消息队列协议）的消息中间件的一种，最初起源于金融系统，用于在分布式系统中存储转发消息，在易用性、扩展性、高可用性等方面表现不俗。 RabbitMQ是用Erlang写的。在Erlang当中，充斥着大量轻量进程，它们之间用消息传递来通信。听起来思路和我们用消息队列的思路是一样的。"}}}]}},"pathContext":{"tag":"Python"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-python-d4626107578cd88d9786.js